<template>
    <!-- http://sensorclip.dk/kontakt/ -->
    <div class="back panel">
        <form action="#" id="forgot_password_form" method="post" novalidate="novalidate">
            <h4>{{ $t('login.forgotten.title') }}</h4>
            <!--<p>
                Indtast venligst din e-mail adresse for at modtage en e-mail med et link til nulstilling af din adgangskode.</p>
            <div class="form-group">
                <label class="control-label" for="email_forgot">
                    E-mail
                </label>
                <input type="text" name="email_forgot" id="email_forgot" class="form-control"
                       autofocus="autofocus"
                       tabindex="5" placeholder="test@example.com"
                v-model="email">
            </div>-->
            <div class="form-group">
                <p>{{ $t('login.forgotten.desc') }} </p>
            </div>
            <div class="form-group">
                <p>
                    <a href="http://www.sensorclip.dk/kontakt" target="_blank">http://www.sensorclip.dk/kontakt</a>
                </p>
            </div>
            <div class="panel-footer">
                <button class="btn pull-right" style="display: none" name="submitLogin" type="submit" tabindex="6">
                    <i class="icon-ok text-success"></i>
                    Send e-mail
                </button>
                <button type="button" href="#" class="btn pull-right btn-space" tabindex="7"
                        @click="confirmBack">
                    <i class="icon-caret-left"></i>
                    {{ $t('btn_back') }}
                </button>
            </div>
        </form>

    </div>
</template>
<script>
    export default {
        data(){
            return {
                email: ""
            }
        },
        computed: {
            modified(){
                return this.email.length > 0
            }
        },
        methods: {
            confirmBack() {
                if (!this.modified || confirm("Er du sikker på du vil annullere og gå tilbage?")) {
                    this.$emit('back');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/login/recover.vue